module.exports = __webpack_public_path__ + "static/Rum-Times-4-2500-a59ecb028259af981b0aa79015091afa.jpg";